export class BackendError extends Error {

    traceId: string;
    translation?: ErrorTranslation;

    constructor(message: string, traceId: string, translation?: ErrorTranslation) {
        super(message);
        this.traceId = traceId;
        this.translation = translation;

        Object.setPrototypeOf(this, BackendError.prototype);
    }
}

export type ErrorTranslation = {
    errorCode: string,
    params: any
}